//import { startProgress, doneProgress } from '../components/progressbar/progressbar';
import { apiUrl } from './apiConfig';

export const apiRequest = async (endpoint, method = 'GET', data = null) => {
  const token = localStorage.getItem('token');
  const startProgress = window.startProgress;
  const doneProgress = window.doneProgress;
  startProgress && startProgress();
  //startProgress();
  const headers = {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };

  const options = {
    method,
    headers,
    ...(data && { body: JSON.stringify(data) }),
  };

  try {
    const response = await fetch(`${apiUrl}${endpoint}`, options);
    const result = await response.json();
    //doneProgress();
    return result;
  } catch (error) {
    //doneProgress();
    throw error;
  } finally {
    doneProgress && doneProgress();
  }
};
